import { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { truncateLabel } from '../../../../../helpers/string-helpers/string-helpers';
import {
  useSelectedInitiativeFocus,
  useSelectedInitiativeFocusTrends,
} from '../../../../../store/process-analysis-store/process-analysis-store.hooks';
import { LineChart } from '../../../components/line-chart/line-chart';
import { useChartData } from './line-chart.hooks';

export const InitiativeFocusLineChart = forwardRef<HTMLDivElement>((_, ref) => {
  const { t } = useTranslation();
  const selectedInitiativeFocus = useSelectedInitiativeFocus();
  const selectedInitiativeFocusTrends = useSelectedInitiativeFocusTrends();

  const chartData = useChartData();
  const [hoveredInitiative, setHoveredInitiative] = useState<string | null>(null);

  const formatValue = (value: number | null): string => {
    return value !== null && value !== undefined ? `${value}%` : t('common.labels.not_available');
  };

  return (
    <LineChart
      ref={ref}
      chartData={chartData}
      selectedItems={selectedInitiativeFocus}
      selectedTrends={selectedInitiativeFocusTrends}
      hoveredItem={hoveredInitiative}
      setHoveredItem={setHoveredInitiative}
      yAxisConfig={{
        domain: [0, 100],
        ticks: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        label: '%',
      }}
      formatItemName={truncateLabel}
      formatValue={formatValue}
      labelMaxLength={25}
    />
  );
});
